import { Injectable } from '@angular/core';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';

@Injectable()
export class AccountService {
  constructor(private httpService: HttpService, private appConfigService: AppConfigService) {}

  public createAccount(account: any): Observable<any> {
    return this.httpService.makePost<any, any>('create', account);
  }
  public getAccountProperties(): Observable<any> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if(this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    return this.httpService.makeGet<any>('getsignupquestions', null, null, {'CompanyGuid': companyGUID});
  }
  public getEmailDomains(): Observable<any> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if(this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    return this.httpService.makeGet<any>('getemaildomains', null, null, {'CompanyGuid': companyGUID});
  }
  public validateAccount(authToken: string): Observable<any> {
    return this.httpService.makePost<any, any>('validateaccount', {authToken, validationType: 'Email'});
  }
}
